// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pp-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    max-width: 1000vh;
    max-height: 1000vh;
    width: auto;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    overflow-y: scroll;
    background: rgb(34, 31, 31);
    border-radius: 10px;
  }
  
  .pp-modal-content {
    background: none;
    width: 1250px;
    max-height: 100vh;
    height: 810px;
    padding: 20px;
    position: relative;
    overflow-y: scroll;
    color: white;
    border-radius: 20px;
    margin-top: 10px;
  }

  .pp-modal-close {
    position: absolute;
    top: 10px;
    right: 20px;
    background: none;
    font-size: 24px;
    border: none;
    cursor: pointer;
    width: 40px;
    justify-content: left;
    margin-right: 20px;
    margin-top: -10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/common/PopupPages/PageProfile.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,aAAa;IAEb,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;EACnB","sourcesContent":[".pp-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    max-width: 1000vh;\n    max-height: 1000vh;\n    width: auto;\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    overflow-y: scroll;\n    background: rgb(34, 31, 31);\n    border-radius: 10px;\n  }\n  \n  .pp-modal-content {\n    background: none;\n    width: 1250px;\n    max-height: 100vh;\n    height: 810px;\n    border-radius: 8px;\n    padding: 20px;\n    position: relative;\n    overflow-y: scroll;\n    color: white;\n    border-radius: 20px;\n    margin-top: 10px;\n  }\n\n  .pp-modal-close {\n    position: absolute;\n    top: 10px;\n    right: 20px;\n    background: none;\n    font-size: 24px;\n    border: none;\n    cursor: pointer;\n    width: 40px;\n    justify-content: left;\n    margin-right: 20px;\n    margin-top: -10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
